<template>
  <section class="facility">
    <Header
      @toggle="sideMenu = !sideMenu"
      :headerData="headerNav"
      :showSideBar="sideMenu"
    />
    <div class="wrapper">
      <SideMenu
        @click="sideMenu = false"
        :sideData="sideMenuNav"
        :showSideBar="sideMenu"
      />
      <main
        class="content"
        :class="{ overlay: sideMenu }"
        @click="sideMenu = false"
      >
        <router-view />
        <Footer class="d-none" />
      </main>
    </div>
  </section>
</template>

<script lang="js">
import Header from "@/components/dashboard_layout/Header.vue"
import Footer from "@/components/dashboard_layout/Footer.vue"
import SideMenu from "@/components/dashboard_layout/SideMenu.vue";
import headerRoute from "../dashboard/routes/header.routes.js"
import sideRoute from "../dashboard/routes/side.routes.js";

export default {
  name: "HealthThink",
  components:{
    Header,
    Footer,
    SideMenu,
  },
  data() {
    return {
      sideMenu: false,
      sideMenuNav: [],
      headerNav: [],
    };
  },
  methods: {
    setRoute() {
    this.sideMenuNav = [...sideRoute];
    this.headerNav = [...headerRoute];
    },
  },
  created() {
    this.setRoute();
  },
};
</script>

<style lang="scss" scoped>
section.facility {
  main.shrink {
    width: calc(100% + 250px);
    margin-left: 250px;
    transition: all 0.8s ease-in-out;
  }

  main.content {
    width: calc(100% - 250px);
    margin-left: 250px;
    // margin-bottom: 1.5rem;
    min-height: 100vh;
    background-color: #e5e5e5;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-blend-mode: overlay;
    background-attachment: fixed;
    margin-top: 0;
    overflow-x: hidden;
    transition: all 0.8s ease-in-out;
    padding-top: 80px;
  }

  @media screen and (max-width: 810px) {
    main.content {
      margin-left: 0;
      width: 100%;
    }

    main.shrink {
      width: calc(100% - 250px);
      margin-left: 250px;
      transition: all 0.8s ease-in-out;
    }

    main.overlay- {
      // display: block;
      // opacity: 1;
      min-height: 100vh;
      min-width: 100vw;
      background-color: #0000002d;
      position: fixed;
      z-index: 4;
      transition: all 0.5s ease-in-out;
      bottom: 0;
      left: 0;
      // top: 64px;
      right: 0;
    }
  }
}
</style>
